import {
  SharedAction,
  LOAD_LIBRARY_SUCCESS,
  PAGE_LOADING,
  SET_TOKEN,
  CREATE_APPLICATION_SUCCESS,
  SHOW_ALERT,
  REMOVE_ALERT,
  SET_CLIENT,
  UNSUSCRIBE_FROM_EMAILS_SUCCESS,
  SUBMIT_PRE_QUALIFICATION,
  SUBMIT_PRE_QUALIFICATION_SUCCESS,
  SET_PRE_QUALIFYING_FLAG,
  SET_LOCATION_ID,
  SET_PRE_QUALIFICATION_RESULT,
  SUBMIT_DEALER_APPLICATION_SUCCESS,
  LOAD_STATES_SUCCESS,
  LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS_SUCCESS,
  SET_CUSTOMER_PORTAL_LINK_ID,
  UPDATE_APPLICATION_SUCCESS,
  SET_SELECTED_LANGUAGE_ID,
  SET_TARGET_ASSIGNED_TO_ID_FOR_NEW_APPLICATIONS,
  CREATE_DOWN_PAYMENT_LINK_SUCCESS,
  CREATE_DOWN_PAYMENT_LINK,
  SET_IS_LOADING_DOWN_PAYMENT_LINK,
  SET_LEAD_SOURCE_TRACKING_DATA
} from './actions';
import { combineReducers } from 'redux';
import { State } from '../../Models/State';
import { LookupItem } from '../../Models/LookupItem';
import { Alert } from '../../Components/Shared/Interfaces/Alert';
import { reject } from 'ramda';
import { ApplicationFormConfig, ICustomField, LanguageTranslation, PreQualifyCustomer, Store } from '@amsanalytics/react-shared-library';
import { CustomerPortalAction, GET_PORTAL_PRE_QUALIFICATION_RESULT_SUCCESS } from '../CustomerPortal/actions';
import { CustomerReferenceRelationship } from '../../Models/CustomerReferenceRelationship';
import { PortalPreQualifyInfo } from '../../Models/PortalPreQualifyInfo';
import { defaultLeadSourceParameters, LeadSourceTrackingData } from '../../Models/LeadSourceParameters';
import {CreateApplicationFromFormResults} from "../../Models/CreateApplicationFromFormResults";
import {CuratedSiteDownPaymentRequestDetails} from "../../Models/CuratedSiteDownPaymentRequestDetails";

export interface SharedState {
  maritalStatuses: LookupItem[],
  housingStatuses: LookupItem[],
  incomePeriods: LookupItem[],
  incomeTypes: LookupItem[],
  bookoutSources: LookupItem[],
  jobCodes: LookupItem[],
  customFields: ICustomField[] | null,
  states: State[],
  stores: Store[],
  creditApplicationApplicantConfiguration: ApplicationFormConfig | null;
  creditApplicationCoApplicantConfiguration: ApplicationFormConfig | null;
  disclosure: string | null;
  spanishDisclosure: string | null;
  preQualifyDisclosure: string | null;
  spanishPreQualifyDisclosure: string | null;
  loading: boolean,
  token: string | null,
  clientId: string | null
  clientName: string,
  customerPortalLinkId: string | null,
  createApplicationFromFormResults: CreateApplicationFromFormResults | null,
  dealerApplicationCreated: boolean,
  emailUnsubscribed: boolean,
  maximumNumberOfApplicants: number,
  minimumMonthsOfAddressInformation: number,
  minimumMonthsOfEmploymentInformation: number,
  alerts: Alert[];
  preQualificationCredentials: Partial<PreQualifyCustomer>; // pre-qual credentials for the current session
  isPreQualificationInProgress: boolean; // whether or not the system is pre-qualifying the customer
  preQualifyCustomerInfo: PortalPreQualifyInfo | null; // Pre-qualify customer info and results
  locationId: string | null;
  targetAssignedToIdForNewApplications: string | null;
  privacyPolicyUrl: string | null;
  termsConditionsUrl: string | null;
  locationAddress: string | null;
  locationPhone: string | null;
  showPreQualifyIncomeField: boolean; // whether or not to show the pre-qualify income field
  isPreQualifyIncomeRequired: boolean; // whether or not the pre-qualify income field is required
  showPreQualifyDownPaymentField: boolean; // whether or not to show the pre-qualify down payment field
  isPreQualifyDownPaymentRequired: boolean; // whether or not the pre-qualify down payment field is required
  dealerApplicationSubmittedRedirectUrl: string | null;
  applicantAddressStateIdsToFilterBy: string[]; // list of state ids by which we should filter the list of states for the address state dropdown. If empty, all states will be shown.
  employerAddressStateIdsToFilterBy: string[]; // list of state ids by which we should filter the list of states for the employer state dropdown. If empty, all states will be shown.
  driverLicenseStateIdsToFilterBy: string[]; // list of state ids by which we should filter the list of states for the driver license state dropdown. If empty, all states will be shown.
  identificationTypes: LookupItem[];
  shouldValidateSsn: boolean; // whether or not to validate the SSN field
  shouldValidateAddress: boolean; // Whether or not the client should validate the primary address when use fills out an application via the Credit Stepper.
  relationshipsToApplicant: LookupItem[]; // list of relationships to applicant
  customerReferenceRelationships: CustomerReferenceRelationship[]; // list of customer reference relationships
  selectedLanguageId: '1' | '2';// ID of the selected language
  languageTranslations: LanguageTranslation[]; // list of language translations for switching between english and spanish
  allowSpanishTranslation: boolean; // whether or not to allow spanish translation
  embedCreditApplicationVersion: number | null; // 1 = Full Credit Application, 2 = Simplified Credit Application
  applicationStyleConfig?: string | null;
  headerHtml: string | null;
  footerHtml: string | null;
  curatedSiteDownPaymentRequestDetails: CuratedSiteDownPaymentRequestDetails | null;
  isCreatingDownPaymentLink: boolean;
  leadSourceParameters: LeadSourceTrackingData; // Lead source tracking parameters we capture from the URL.
  showLocationOnNewCreditApp: boolean; // Whether or not to show the location on the new credit application.
}

const INITIAL_STATE: SharedState = {
  states: [],
  stores: [],
  maritalStatuses: [],
  housingStatuses: [],
  incomePeriods: [],
  incomeTypes: [],
  bookoutSources: [],
  jobCodes: [],
  creditApplicationApplicantConfiguration: null,
  creditApplicationCoApplicantConfiguration: null,
  disclosure: null,
  spanishDisclosure: null,
  preQualifyDisclosure: null,
  spanishPreQualifyDisclosure: null,
  token: null,
  clientId: null,
  clientName: '',
  customerPortalLinkId: null,
  loading: true,
  createApplicationFromFormResults: null,
  dealerApplicationCreated: false,
  emailUnsubscribed: false,
  alerts: [],
  maximumNumberOfApplicants: 2,
  minimumMonthsOfAddressInformation: 0,
  minimumMonthsOfEmploymentInformation: 0,
  customFields: null,
  isPreQualificationInProgress: false,
  preQualifyCustomerInfo: null,
  preQualificationCredentials: {},
  locationId: null,
  targetAssignedToIdForNewApplications: null,
  privacyPolicyUrl: null,
  termsConditionsUrl: null,
  locationAddress: null,
  locationPhone: null,
  showPreQualifyIncomeField: false,
  isPreQualifyIncomeRequired: false,
  showPreQualifyDownPaymentField: false,
  isPreQualifyDownPaymentRequired: false,
  dealerApplicationSubmittedRedirectUrl: null,
  applicantAddressStateIdsToFilterBy: [],
  employerAddressStateIdsToFilterBy: [],
  driverLicenseStateIdsToFilterBy: [],
  identificationTypes: [],
  shouldValidateSsn: false,
  shouldValidateAddress: false,
  relationshipsToApplicant: [],
  customerReferenceRelationships: [],
  selectedLanguageId: '1',
  languageTranslations: [],
  allowSpanishTranslation: true,
  embedCreditApplicationVersion: null,
  applicationStyleConfig: null,
  headerHtml: null,
  footerHtml: null,
  curatedSiteDownPaymentRequestDetails: null,
  isCreatingDownPaymentLink: false,
  leadSourceParameters: defaultLeadSourceParameters,
  showLocationOnNewCreditApp: false, // Whether or not to show the location on the new credit application.
};

const statesReducer = (state: State[] = INITIAL_STATE.states, action: CustomerPortalAction | SharedAction): State[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.states;
    case LOAD_STATES_SUCCESS:
      return action.payload.states;
    default:
      return state;
  }
};
const maritalStatusesReducer = (state: LookupItem[] = INITIAL_STATE.maritalStatuses, action: SharedAction): LookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.maritalStatuses;
    default:
      return state;
  }
};
const housingStatusesReducer = (state: LookupItem[] = INITIAL_STATE.housingStatuses, action: SharedAction): LookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.housingStatuses;
    default:
      return state;
  }
};
const imcomePeriodsReducer = (state: LookupItem[] = INITIAL_STATE.incomePeriods, action: SharedAction): LookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.incomePeriods;
    default:
      return state;
  }
};
const incomeTypesReducer = (state: LookupItem[] = INITIAL_STATE.incomeTypes, action: SharedAction): LookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.incomeTypes;
    default:
      return state;
  }
};
const bookoutSourcesReducer = (state: LookupItem[] = INITIAL_STATE.bookoutSources, action: SharedAction): LookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.bookoutSources;
    default:
      return state;
  }
};
const creditApplicationCustomFieldReducer = (state: ICustomField[] | null = INITIAL_STATE.customFields, action: SharedAction): ICustomField[] | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.customFields;
    default:
      return state;
  }
};
const creditApplicationApplicantConfigurationReducer = (state: ApplicationFormConfig | null = INITIAL_STATE.creditApplicationApplicantConfiguration, action: SharedAction): ApplicationFormConfig | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      {
        if (action.payload.creditApplicationApplicantConfiguration !== null) {
          return JSON.parse(action.payload.creditApplicationApplicantConfiguration) as ApplicationFormConfig;
        } else {
          return action.payload.creditApplicationApplicantConfiguration;
        }
      }
    default:
      return state;
  }
};
const creditApplicationCoApplicantConfigurationReducer = (state: ApplicationFormConfig | null = INITIAL_STATE.creditApplicationCoApplicantConfiguration, action: SharedAction): ApplicationFormConfig | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      {
        if (action.payload.creditApplicationCoApplicantConfiguration !== null) {
          return JSON.parse(action.payload.creditApplicationCoApplicantConfiguration) as ApplicationFormConfig;
        } else {
          return action.payload.creditApplicationCoApplicantConfiguration;
        }
      }
    default:
      return state;
  }
}
const maximumNumberOfApplicantsReducer = (state: number = INITIAL_STATE.maximumNumberOfApplicants, action: SharedAction): number => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.maximumNumberOfApplicants ?? 3;
    default:
      return state;
  }
}
const minimumMonthsOfAddressInformationReducer = (state: number = INITIAL_STATE.minimumMonthsOfAddressInformation, action: SharedAction): number => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.minimumMonthsOfAddressInformation ?? 0;
    default:
      return state;
  }
}

const minimumMonthsOfEmploymentInformationReducer = (state: number = INITIAL_STATE.minimumMonthsOfEmploymentInformation, action: SharedAction): number => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.minimumMonthsOfEmploymentInformation ?? 0;
    default:
      return state;
  }
}

const disclosureReducer = (state: string | null = INITIAL_STATE.disclosure, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.disclosure ?? null;
    default:
      return state;
  }
}

const preQualifyDisclosureReducer = (state: string | null = INITIAL_STATE.preQualifyDisclosure, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.preQualifyDisclosure ?? null;
    default:
      return state;
  }
}

const loadingReducer = (state: boolean = INITIAL_STATE.loading, action: SharedAction): boolean => {
  switch (action.type) {
    case PAGE_LOADING:
      return action.payload.isLoading;
    default:
      return state;
  }
};
const tokenReducer = (state: string | null = INITIAL_STATE.token, action: SharedAction): string | null => {
  switch (action.type) {
    case SET_TOKEN:
      return action.payload.token;
    default:
      return state;
  }
}
const clientIdReducer = (state: string | null = INITIAL_STATE.clientId, action: SharedAction): string | null => {
  switch (action.type) {
    case SET_CLIENT:
      return action.payload.clientId;
    default:
      return state;
  }
}
const clientNameReducer = (state: string = INITIAL_STATE.clientName, action: SharedAction): string => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.clientName ?? state;
    default:
      return state;
  }
}
const customerPortalLinkReducer = (state: string | null = INITIAL_STATE.customerPortalLinkId, action: SharedAction): string | null => {
  switch (action.type) {
    case SET_CUSTOMER_PORTAL_LINK_ID:
      return action.payload.customerPortalLinkId;
    default:
      return state;
  }
}
const createApplicationFromFormResultsReducer = (state: CreateApplicationFromFormResults | null = INITIAL_STATE.createApplicationFromFormResults, action: SharedAction): CreateApplicationFromFormResults | null => {
  switch (action.type) {
    case UPDATE_APPLICATION_SUCCESS:
    case CREATE_APPLICATION_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
const alertsReducer = (state: Alert[] = INITIAL_STATE.alerts, action: SharedAction): Alert[] => {
  switch (action.type) {
    case SHOW_ALERT:
      return [...state, action.payload.notification];
    case REMOVE_ALERT:
      return reject((a: Alert) => a.id === action.payload.notificationId, state);
    default:
      return state;
  }
}
const emailUnsubscribedReducer = (state: boolean = INITIAL_STATE.emailUnsubscribed, action: SharedAction): boolean => {
  switch (action.type) {
    case UNSUSCRIBE_FROM_EMAILS_SUCCESS:
      return true;
    default:
      return state;
  }
}
const isPreQualificationInProgressReducer = (state: boolean = INITIAL_STATE.isPreQualificationInProgress, action: SharedAction): boolean => {
  switch (action.type) {
    case SUBMIT_PRE_QUALIFICATION:
      return true;
    case SUBMIT_PRE_QUALIFICATION_SUCCESS:
      return false;
    case SET_PRE_QUALIFYING_FLAG:
      return action.payload.flag;
    default:
      return state;
  }
}

const preQualifyCustomerInfoReducer = (state: PortalPreQualifyInfo | null = INITIAL_STATE.preQualifyCustomerInfo, action: SharedAction | CustomerPortalAction): PortalPreQualifyInfo | null => {
  switch (action.type) {
    case SUBMIT_PRE_QUALIFICATION_SUCCESS:
      return action.payload.result;
    case SET_PRE_QUALIFICATION_RESULT:
      return action.payload.result;
    case GET_PORTAL_PRE_QUALIFICATION_RESULT_SUCCESS:
      return action.payload.preQualificationResult;
    default:
      return state;
  }
}

const preQualificationCredentialsReducer = (state: Partial<PreQualifyCustomer> = INITIAL_STATE.preQualificationCredentials, action: SharedAction): Partial<PreQualifyCustomer> => {
  switch (action.type) {
    case SUBMIT_PRE_QUALIFICATION:
      return action.payload.preQualifySubmissionInfo;
    default:
      return state;
  }
}

const locationIdReducer = (state: string | null = INITIAL_STATE.locationId, action: SharedAction): string | null => {
  switch (action.type) {
    case SET_LOCATION_ID:
      return action.payload.locationId;
    default:
      return state;
  }
}

const privacyPolicyUrlReducer = (state: string | null = INITIAL_STATE.privacyPolicyUrl, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.privacyPolicyUrl || null;
    default:
      return state;
  }
}

const termsConditionsUrlReducer = (state: string | null = INITIAL_STATE.termsConditionsUrl, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.termsConditionsUrl || null;
    default:
      return state;
  }
}

const locationAddressReducer = (state: string | null = INITIAL_STATE.locationAddress, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.locationAddress || null;
    default:
      return state;
  }
}

const locationPhoneReducer = (state: string | null = INITIAL_STATE.locationPhone, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.locationPhone || null;
    default:
      return state;
  }
}

const jobCodesReducer = (state: LookupItem[] = INITIAL_STATE.jobCodes, action: SharedAction): LookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.jobCodes || [];
    default:
      return state;
  }
}

const storesReducer = (state: Store[] = INITIAL_STATE.stores, action: SharedAction): Store[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.stores || [];
    default:
      return state;
  }
}

const dealerApplicationCreatedReducer = (state: boolean = INITIAL_STATE.dealerApplicationCreated, action: SharedAction): boolean => {
  switch (action.type) {
    case SUBMIT_DEALER_APPLICATION_SUCCESS:
      return true;
    default:
      return state;
  }
}

const showPreQualifyIncomeFieldReducer = (state: boolean = INITIAL_STATE.showPreQualifyIncomeField, action: SharedAction): boolean => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.showPreQualifyIncomeField || false
    default:
      return state;
  }
}

const dealerApplicationSubmittedRedirectUrlReducer = (state: string | null = INITIAL_STATE.dealerApplicationSubmittedRedirectUrl, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.dealerApplicationSubmittedRedirectUrl || null;
    default:
      return state;
  }
}

const isPreQualifyIncomeRequiredReducer = (state: boolean = INITIAL_STATE.isPreQualifyIncomeRequired, action: SharedAction): boolean => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.isPreQualifyIncomeRequired || false;
    default:
      return state;
  }
}

const showPreQualifyDownPaymentFieldReducer = (state: boolean = INITIAL_STATE.showPreQualifyDownPaymentField, action: SharedAction): boolean => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.showPreQualifyDownPaymentField || false
    default:
      return state;
  }
}

const isPreQualifyDownPaymentRequiredReducer = (state: boolean = INITIAL_STATE.isPreQualifyDownPaymentRequired, action: SharedAction): boolean => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.isPreQualifyDownPaymentRequired || false;
    default:
      return state;
  }
}

const applicantAddressStateIdsToFilterByReducer = (state: string[] = INITIAL_STATE.applicantAddressStateIdsToFilterBy, action: SharedAction): string[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.applicantAddressStateIdsToFilterBy || [];
    default:
      return state;
  }
}

const employerAddressStateIdsToFilterByReducer = (state: string[] = INITIAL_STATE.employerAddressStateIdsToFilterBy, action: SharedAction): string[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.employerAddressStateIdsToFilterBy || [];
    default:
      return state;
  }
}

const driverLicenseStateIdsToFilterByReducer = (state: string[] = INITIAL_STATE.driverLicenseStateIdsToFilterBy, action: SharedAction): string[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.driverLicenseStateIdsToFilterBy || [];
    default:
      return state;
  }
}

const identificationTypesReducer = (state: LookupItem[] = INITIAL_STATE.identificationTypes, action: SharedAction): LookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.identificationTypes || [];
    default:
      return state;
  }
}

const shouldValidateSsnReducer = (state: boolean = INITIAL_STATE.shouldValidateSsn, action: SharedAction): boolean => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.shouldValidateSsn || false;
    default:
      return state;
  }
}

const shouldValidateAddressReducer = (state: boolean = INITIAL_STATE.shouldValidateAddress, action: SharedAction): boolean => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.shouldValidateAddress || false;
    default:
      return state;
  }
}

const relationshipsToApplicantReducer = (state: LookupItem[] = INITIAL_STATE.relationshipsToApplicant, action: SharedAction): LookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.relationshipsToApplicant || [];
    default:
      return state;
  }
}

const customerReferenceRelationshipsReducer = (state: CustomerReferenceRelationship[] = INITIAL_STATE.customerReferenceRelationships, action: SharedAction): CustomerReferenceRelationship[] => {
  switch (action.type) {
    case LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS_SUCCESS:
      return action.payload.customerReferenceRelationships;
    default:
      return state;
  }
}

const selectedLanguageIdReducer = (state: string = INITIAL_STATE.selectedLanguageId, action: SharedAction): '1' | '2' => {
  switch (action.type) {
    case SET_SELECTED_LANGUAGE_ID:
      return action.payload.languageId as ('1' | '2');
    default:
      return state as ('1' | '2');
  }
}

const languageTranslationsReducer = (state: LanguageTranslation[] = INITIAL_STATE.languageTranslations, action: SharedAction): LanguageTranslation[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.languageTranslations || [];
    default:
      return state;
  }
}

const spanishDisclosureReducer = (state: string | null = INITIAL_STATE.spanishDisclosure, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.spanishDisclosure || null;
    default:
      return state;
  }
}

const spanishPreQualifyDisclosureReducer = (state: string | null = INITIAL_STATE.spanishPreQualifyDisclosure, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.spanishPreQualifyDisclosure || null;
    default:
      return state;
  }
}

const allowSpanishTranslationReducer = (state: boolean = INITIAL_STATE.allowSpanishTranslation, action: SharedAction): boolean => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.allowSpanishTranslation ?? true;
    default:
      return state;
  }
}

const targetAssignedToIdForNewApplicationsReducer = (state: string | null = INITIAL_STATE.targetAssignedToIdForNewApplications, action: SharedAction): string | null => {
  switch (action.type) {
    case SET_TARGET_ASSIGNED_TO_ID_FOR_NEW_APPLICATIONS:
      return action.payload.targetAssignedToId;
    default:
      return state;
  }
}

const embedLosCreditApplicationVersionReducer = (state: number | null = INITIAL_STATE.embedCreditApplicationVersion, action: SharedAction): number | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.embedCreditApplicationVersion ?? true;
    default:
      return state;
  }
}

const applicationStyleConfigReducer = (state: string | null | undefined = INITIAL_STATE.applicationStyleConfig, action: SharedAction): string | null | undefined => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.applicationStyleConfig;
    default:
      return state;
  }
}

const headerHtmlReducer = (state: string | null = INITIAL_STATE.headerHtml, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.customerPortalHeaderHtml;
    default:
      return state;
  }
}

const footerHtmlReducer = (state: string | null = INITIAL_STATE.footerHtml, action: SharedAction): string | null => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.customerPortalFooterHtml;
    default:
      return state;
  }
}

const curatedSiteDownPaymentRequestDetailsReducer = (state: CuratedSiteDownPaymentRequestDetails | null = INITIAL_STATE.curatedSiteDownPaymentRequestDetails, action: SharedAction): CuratedSiteDownPaymentRequestDetails | null => {
  switch (action.type) {
    case CREATE_DOWN_PAYMENT_LINK_SUCCESS:
      return action.payload
    default:
      return state;
  }
}

const isCreatingDownPaymentLinkReducer = (state: boolean = INITIAL_STATE.isCreatingDownPaymentLink, action: SharedAction): boolean => {
  switch (action.type) {
    case CREATE_DOWN_PAYMENT_LINK:
      return true;
    case CREATE_DOWN_PAYMENT_LINK_SUCCESS:
      return false;
    case SET_IS_LOADING_DOWN_PAYMENT_LINK:
      return action.payload.isLoading;
    default:
      return state;
  }
}

const leadSourceParametersReducer = (state: LeadSourceTrackingData = INITIAL_STATE.leadSourceParameters, action: SharedAction): LeadSourceTrackingData => {
  switch (action.type) {
    case SET_LEAD_SOURCE_TRACKING_DATA:
      return action.payload.leadSourceTrackingInfo;
    default:
      return state;
  }
}

const showLocationOnNewCreditAppReducer = (state: boolean = INITIAL_STATE.showLocationOnNewCreditApp, action: SharedAction): boolean => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.showLocationOnNewCreditApp ?? false;
    default:
      return state;
  }
}

export const sharedReducer = combineReducers({
  maritalStatuses: maritalStatusesReducer,
  incomePeriods: imcomePeriodsReducer,
  incomeTypes: incomeTypesReducer,
  housingStatuses: housingStatusesReducer,
  disclosure: disclosureReducer,
  preQualifyDisclosure: preQualifyDisclosureReducer,
  states: statesReducer,
  customFields: creditApplicationCustomFieldReducer,
  creditApplicationApplicantConfiguration: creditApplicationApplicantConfigurationReducer,
  creditApplicationCoApplicantConfiguration: creditApplicationCoApplicantConfigurationReducer,
  token: tokenReducer,
  clientId: clientIdReducer,
  clientName: clientNameReducer,
  loading: loadingReducer,
  createApplicationFromFormResults: createApplicationFromFormResultsReducer,
  emailUnsubscribed: emailUnsubscribedReducer,
  maximumNumberOfApplicants: maximumNumberOfApplicantsReducer,
  minimumMonthsOfAddressInformation: minimumMonthsOfAddressInformationReducer,
  minimumMonthsOfEmploymentInformation: minimumMonthsOfEmploymentInformationReducer,
  alerts: alertsReducer,
  isPreQualificationInProgress: isPreQualificationInProgressReducer,
  preQualifyCustomerInfo: preQualifyCustomerInfoReducer,
  preQualificationCredentials: preQualificationCredentialsReducer,
  locationId: locationIdReducer,
  privacyPolicyUrl: privacyPolicyUrlReducer,
  termsConditionsUrl: termsConditionsUrlReducer,
  locationAddress: locationAddressReducer,
  locationPhone: locationPhoneReducer,
  jobCodes: jobCodesReducer,
  stores: storesReducer,
  showPreQualifyIncomeField: showPreQualifyIncomeFieldReducer,
  isPreQualifyIncomeRequired: isPreQualifyIncomeRequiredReducer,
  dealerApplicationCreated: dealerApplicationCreatedReducer,
  dealerApplicationSubmittedRedirectUrl: dealerApplicationSubmittedRedirectUrlReducer,
  applicantAddressStateIdsToFilterBy: applicantAddressStateIdsToFilterByReducer,
  employerAddressStateIdsToFilterBy: employerAddressStateIdsToFilterByReducer,
  driverLicenseStateIdsToFilterBy: driverLicenseStateIdsToFilterByReducer,
  identificationTypes: identificationTypesReducer,
  shouldValidateSsn: shouldValidateSsnReducer,
  shouldValidateAddress: shouldValidateAddressReducer,
  relationshipsToApplicant: relationshipsToApplicantReducer,
  customerReferenceRelationships: customerReferenceRelationshipsReducer,
  bookoutSources: bookoutSourcesReducer,
  customerPortalLinkId: customerPortalLinkReducer,
  showPreQualifyDownPaymentField: showPreQualifyDownPaymentFieldReducer,
  isPreQualifyDownPaymentRequired: isPreQualifyDownPaymentRequiredReducer,
  selectedLanguageId: selectedLanguageIdReducer,
  languageTranslations: languageTranslationsReducer,
  spanishDisclosure: spanishDisclosureReducer,
  spanishPreQualifyDisclosure: spanishPreQualifyDisclosureReducer,
  allowSpanishTranslation: allowSpanishTranslationReducer,
  targetAssignedToIdForNewApplications: targetAssignedToIdForNewApplicationsReducer,
  embedCreditApplicationVersion: embedLosCreditApplicationVersionReducer,
  applicationStyleConfig: applicationStyleConfigReducer,
  headerHtml: headerHtmlReducer,
  footerHtml: footerHtmlReducer,
  curatedSiteDownPaymentRequestDetails: curatedSiteDownPaymentRequestDetailsReducer,
  isCreatingDownPaymentLink: isCreatingDownPaymentLinkReducer,
  leadSourceParameters: leadSourceParametersReducer,
  showLocationOnNewCreditApp: showLocationOnNewCreditAppReducer
});
